<template>
  <div class="legal-agency">
    <ul>
      <li :class="{ active: activeIndex == 0 }" @click="activeIndex = 0">
        法律援助中心
      </li>
      <li :class="{ active: activeIndex == 1 }" @click="activeIndex = 1">
        公证处
      </li>
      <li :class="{ active: activeIndex == 2 }" @click="activeIndex = 2">
        律师事务所
      </li>
    </ul>
    <component :is="view"></component>
  </div>
</template>

<script>
import legalCenter from "@/views/luzhai/legal-center.vue";
import notarization from "@/views/luzhai/notarization.vue";
import lawFirm from "@/views/luzhai/law-firm.vue";

export default {
  name: "legalAgency",
  watch: {
    activeIndex(i) {
      if (i == 0) {
        this.view = legalCenter;
      } else if (i == 1) {
        this.view = notarization;
      } else if (i == 2) {
        this.view = lawFirm;
      }
    }
  },
  data() {
    return {
      activeIndex: 0,
      view: legalCenter
    };
  }
};
</script>

<style lang="less" scoped>
.legal-agency {
  padding: 0 15px 43px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  ul {
    padding: 15px 15px 0;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    display: flex;
    align-items: center;
    background-color: #fff;
    li {
      padding: 0 13px 0 15px;
      height: 30px;
      line-height: 30px;
      border: 1px solid #e1e1e9;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.03);
      border-radius: 2px;
      color: #030f1c;
      font-size: 13px;
      text-align: center;
    }
    li ~ li {
      margin-left: 5px;
    }
    li.active {
      position: relative;
      background-color: #4aa8ff;
      color: #fff;
      border: none;
      &::after {
        content: "";
        position: absolute;
        bottom: -3px;
        left: 50%;
        transform: translateX(-50%);
        width: 5px;
        height: 5px;
        transform: rotate(45deg);
        background-color: #4aa8ff;
      }
    }
  }
}
</style>
